import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

async function blobUrlToFile(blobUrl, fileName) {
    // 1. Загружаем blob-URL как Blob
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    
    // 2. Преобразуем Blob в File
    return new File([blob], fileName, { type: blob.type || 'image/jpeg' });
}

export const getStories = createAsyncThunk(
    'servicesStories/getStories',
    async (data, { rejectWithValue }) => {
        const api = '/stories/get?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return response.data.data.stories;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const createStories = createAsyncThunk(
    'servicesStories/createStories',
    async (data, { rejectWithValue }) => {
        const api = '/stories/create?XDEBUG_SESSION_START=MyVSCode';

        let formData = new FormData();

        // Если data.image - это blob-URL (строка)
        if (typeof data.image === 'string' && data.image.startsWith('blob:')) {
            try {
                const file = await blobUrlToFile(data.image, 'product-image.jpg');
                formData.append('image', file);
            } catch (error) {
                return rejectWithValue('Failed to convert blob URL to file');
            }
        } else if (data.image instanceof Blob) {
            // Если это Blob/File
            formData.append('image', data.image);
        }

        formData.append('data', JSON.stringify(data));

        try {
            const response = await apiInstance.post(api, formData);

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const updateStories = createAsyncThunk(
    'servicesStories/updateStories',
    async (data, { rejectWithValue }) => {
        const api = '/stories/update?XDEBUG_SESSION_START=MyVSCode';

        let formData = new FormData();

        // Если data.image - это blob-URL (строка)
        if (typeof data.image === 'string' && data.image.startsWith('blob:')) {
            try {
                const file = await blobUrlToFile(data.image, 'product-image.jpg');
                formData.append('image', file);
            } catch (error) {
                return rejectWithValue('Failed to convert blob URL to file');
            }
        } else if (data.image instanceof Blob) {
            // Если это Blob/File
            formData.append('image', data.image);
        }

        formData.append('data', JSON.stringify(data));

        try {
            const response = await apiInstance.post(api, formData);

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const deleteStories = createAsyncThunk(
    'servicesStories/deleteStories',
    async (data, { rejectWithValue }) => {
        const api = '/stories/delete?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return response.data.data;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getStoriesStatus: null,
    createStoriesStatus: null,
    updateStoriesStatus: null,
    deleteStoriesStatus: null,
    stories: [],
};

const servicesStoriesSlice = createSlice({
    name: 'servicesStories',
    initialState,
    extraReducers: (builder) => {
        builder
            // getStories
            .addCase(getStories.pending, (state) => { state.getStoriesStatus = 'pending'; })
            .addCase(getStories.fulfilled, (state, action) => { state.getStoriesStatus = 'fulfilled'; state.stories = action.payload; })
            .addCase(getStories.rejected, (state) => { state.getStoriesStatus = 'rejected'; })

            // createStories
            .addCase(createStories.pending, (state) => { state.createStoriesStatus = 'pending'; })
            .addCase(createStories.fulfilled, (state, action) => { state.createStoriesStatus = 'fulfilled'; state.stories.push(action.payload); })
            .addCase(createStories.rejected, (state) => { state.createStoriesStatus = 'rejected'; })

            // updateStories
            .addCase(updateStories.pending, (state) => { state.updateStoriesStatus = 'pending'; })
            .addCase(updateStories.fulfilled, (state, action) => {
                state.updateStoriesStatus = 'fulfilled';
                const index = state.stories.findIndex(story => story.id === action.payload.id);
                if (index !== -1) {
                    state.stories[index] = action.payload;
                }
            })
            .addCase(updateStories.rejected, (state) => { state.updateStoriesStatus = 'rejected'; })

            // deleteStories
            .addCase(deleteStories.pending, (state) => { state.deleteStoriesStatus = 'pending'; })
            .addCase(deleteStories.fulfilled, (state, action) => {
                state.deleteStoriesStatus = 'fulfilled';
                state.stories = state.stories.filter(story => story.id !== action.payload.id);
            })
            .addCase(deleteStories.rejected, (state) => { state.deleteStoriesStatus = 'rejected'; })

            // PURGE
            .addCase(PURGE, () => { return initialState; });
    },
    reducers: {},
});

export const {} = servicesStoriesSlice.actions;

export default servicesStoriesSlice.reducer;
